import styled from "styled-components";
import colors from "constants/colors";

export const BillItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.black5};
  row-gap: 8px;
  padding: 16px;
  margin-top: 16px;

  .title {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .billTable {
    width: 100%;
    table-layout: fixed;
    .description {
      width: 70%;
    }

    .room {
      width: 10%;
      min-width: 60px;
    }
    
    .price {
      width: 10%;
      min-width: 80px;
      justify-content: flex-end;
    }
    
    .action {
      min-width: 64px;
      max-width: 64px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      column-gap: 16px;

      .edit {
        cursor: pointer;
      }

      .edit.disabled {
        cursor: auto;
        svg {
          filter: invert(53%) brightness(88%) contrast(85%);
        }
      }

      .deleted {
        cursor: pointer;
      }

      .delete {
        cursor: pointer;
        svg {
          filter: invert(53%) sepia(97%) saturate(6447%) hue-rotate(330deg) brightness(103%) contrast(105%);
        }
      }
    }
  }

  .transactionTable {
    width: 100%;
    table-layout: fixed;

    th.price {
      padding-right: 26px;
    }

    .transaction {
      width: 48%;
    }

    .status {
      width: 12%;
      min-width: 40px;
    }

    .date {
      width: 20%;
      min-width: 70px;
    }

    .price {
      width: 20%;
      min-width: 60px;
      justify-content: flex-end;
    }

    .action {
      min-width: 94px;
      max-width: 94px;
    }
  }

  .coupon,
  .ratePlan,
  .discount {
    color: ${colors.red};
  }
`;

export const ItemContainer = styled.tr`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .deleted {
    text-decoration: line-through;
  }

  .description {
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors.grey};
  }

  .transaction {
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors.grey};
  }

  .status {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.grey};
    padding-left: 20px;
  }

  .date {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.grey};
    padding-left: 20px;
    white-space: wrap;
  }

  .room {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.grey};
    padding-left: 20px;
  }

  .action {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.grey};
    padding-left: 20px;
  }

  .price {
    display: flex;
    justify-content: ${({ left }) => (left ? 'flex-start':'flex-end')};
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.grey};
    padding-left: 20px;
    column-gap: 8px;
    .amount {
      width: 100%;
      width: 100px;
      text-align: ${({ left }) => (left ? 'left':'right')};
    }
  }

  th {
    color: ${colors.silver};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .approval {
    color: ${colors.green};
  }

  .warning {
    color: ${colors.red};
  }

  .normal {
    color: ${colors.white};
  }

  .lineThrough {
    text-decoration: line-through;
  }
`;

export const BillOfSaleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: ${colors.black1};
  padding: 16px 0;

  .MAT,
  .HST,
  .total,
  .balance {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 16px;
    height: 29px;
    line-height: 29px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: left;
    color: ${colors.white};
  }

  .paid {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: ${colors.black1};
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: left;
    color: ${colors.red};
  }

  .price {
    width: 16%;
    min-width: 80px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .amount {
      width: 100%;
      width: 100px;
      text-align: right;
    }
  }
`;

export const Warning = styled.div`
  color: ${colors.red};
  font-size: 14px;
  font-weight: 600;
  font-style: italic;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
`;
